import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Dropdown,
  DropdownBody,
  DropdownItem,
  getColor,
  Icons,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import utilsCommon from "../../../shared/utils/common";
import DateDropdown from "../../../components/DateDropdown";
import dayjs from "dayjs";
import DocumentBottom from "../../../components/DocumentBottom";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import {
  DocInfo,
  DocumentListResp,
  FolderInfoDTO,
  UploadFile,
} from "../../../types/files";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
import WorkgroupAddModal from "../../../components/WorkgroupAddModal";
import FileUploadModal from "./Modal/FileUploadModal";
import CreateNewFolderModal from "./Modal/CreateNewFolderModal";
import Dropzone, { FileRejection, FileWithPath } from "react-dropzone";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { nanoid } from "@reduxjs/toolkit";
import currentUrlUtils from "../../../shared/utils/currentUrlUtils";
import { t } from "i18next";
import {
  doDeleteDocument,
  handleDocPreview,
  handleDocsDownload,
  handleSetContentFavorite,
  uploadToAIAssistant,
} from "../../../shared/utils/api";
import i18n from "../../../locales/i18n";
import ChangeFileMasterModal from "../../../components/More/ChangeFileMasterModal";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import FolderMoveModal from "../../../components/More/FolderMoveModal";
import ChangeWorkgroupFileAuthModal from "../../../components/More/ChangeWorkgroupFileAuthModal";
import ChooseDriveFolderModal from "../../../components/More/ChooseDriveFolderModal";
import useAppStore from "../../../redux/dispatcher/useAppStore";
import AppRegisterModal from "../../../components/AppRegisterModal";

export const FILE_MENU_LIST = [
  { key: "ALL", resource: t("common.period.all") },
  { key: "FAV", resource: t("bookmark.title") },
  { key: "MINE", resource: t("file.filter.master") },
  { key: "UNREAD", resource: t("file.filter.unread") },
];
export const FILE_READ_REQUEST_LIST = [
  { key: "REQ", resource: t("file.filter.onlyRequest"), value: true },
  { key: "ALL", resource: t("file.filter.all"), value: false },
];
const MAX_CHECK_COUNT = 100; // 100

const WorkgroupFile = ({ workgroupId }: { workgroupId: string }) => {
  const { readRequestFilter, period } = currentUrlUtils.getAllFirstQuery();
  const { workgroupState } = useWorkgroupStore();
  let dropzoneRef: any;

  const toast = useToast();
  const urlParmas = new URLSearchParams(window.location.search);
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  const givenFolderId = urlParmas.get("folderId");
  const INIT_FILTER = {
    page: 0,
    size: 50,
    order: "datedesc",
    search: "",
    readType: "",
    masterUserId: "",
    tagCodes: [workgroupId, givenFolderId ?? "ROOT"],
    date: {
      start:
        period && period === "1day" ? dayjs().subtract(1, "day").valueOf() : 0,
      end: period && period === "1day" ? dayjs().endOf("day").valueOf() : 0,
    },
    folderCode: givenFolderId ?? workgroupId,
  };
  const requestMemuBoxRef = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();
  const {
    documentState,
    doDocUploadFile,
    getDocUploadUidCreate,
    getContentList,
    getReadRequestContentList,
    setAddUploadProgressFiles,
    setUpdateUploadProgressFiles,
    doDocUploadFileComplete,
    getContentFavorite,
    getDocDelete,
    getContentsDownload,
    checkAIDocPermission,
    changeDragItem,
  } = useDocumentStore();
  const { appState } = useAppStore();
  const [requiredRecallSyncId, changeRequiredRecallSyncIds] = useState<
    string[]
  >([]);
  const [progressPercent, setProgressPercent] = useState<number>(0);
  const [buttonClick, setButtonClick] = useState(0);
  const [docInfo, changeDocListInfo] = useState<DocumentListResp>();
  const [folderList, changeFolderList] = useState<FolderInfoDTO[]>();
  const [dateFilter, changeDateFilter] = useState<string>(
    period && period === "1day" ? "1day" : "all"
  );
  const [fileTypeFilter, changeFileFilter] = useState("ALL");
  const [isReadRequest, toggleIsReadRequest] = useState(!!readRequestFilter);
  const [filter, changeFilter] = useState(INIT_FILTER);
  const [modalType, changeModalType] = useState("CLOSE");
  const [uploadFiles, changeUploadFiles] = useState<File[]>();
  const [checkedFileList, changeCheckedFilelist] = useState<DocInfo[]>();
  const [showRequestSubMenu, setShowRequestSubMenu] = useState(false);

  useEffect(() => {
    if (givenFolderId === workgroupId) return;
    changeFilter({
      ...filter,
      page: 0,
      folderCode: givenFolderId ?? workgroupId,
      tagCodes: [workgroupId, givenFolderId ?? "ROOT"],
    });
    if (readRequestFilter) {
      toggleIsReadRequest(readRequestFilter === "true");
    }
  }, [workgroupId, givenFolderId, readRequestFilter, period]);
  useEffect(() => {
    if (!isReadRequest && documentState.recallNum > 0) getContentList(filter);
  }, [documentState.recallNum]);
  useEffect(() => {
    if (isReadRequest)
      getReadRequestContentList({
        pos: 0,
        posCount: 50,
        workgroupId: workgroupId,
      });
    else
      getContentList(filter).then(
        (resp: any) =>
          !!givenFolderId &&
          (!resp.payload || !resp.payload?.folder) &&
          navigate(`${process.env.PUBLIC_URL}/workgroup/${workgroupId}/file`)
      );
  }, [filter]);
  const clickFileMenuOutside = useCallback(
    (e: MouseEvent) => {
      if (
        requestMemuBoxRef.current &&
        !(requestMemuBoxRef.current! as any).contains(e.target)
      ) {
        setShowRequestSubMenu(false);
      }
    },
    [buttonClick]
  );
  useEffect(() => {
    changeDocListInfo(documentState.docListInfo);
    changeFolderList(documentState.docListInfo?.folder?.currntFolderList ?? []);
  }, [documentState.docListInfo]);
  useEffect(() => {
    document.addEventListener("click", clickFileMenuOutside, true);
    return () => {
      document.removeEventListener("click", clickFileMenuOutside, true);
    };
  });
  const checkUpperActionValid = (type: string, docInfos: DocInfo[]) => {
    const checkNotAllDocMaster =
      docInfos.filter((item) => item.masterUser?.userId.toLowerCase() !== myId)
        .length > 0;
    switch (type) {
      // 문서관리자 변경 : 워크그룹장 또는 모든 파일 문서관리자
      case "CHANGE_FILE_MASTER":
        if (
          checkNotAllDocMaster &&
          workgroupState?.workgroupDetail.workgroup.managerId !== myId
        ) {
          toast.toastMsg(
            nanoid(),
            t("file.alert.noMaster.changeMaster"),
            "error"
          );
        } else {
          changeModalType("CHANGE_FILE_MASTER");
        }
        return (
          workgroupState?.workgroupDetail.workgroup.managerId === myId &&
          !checkNotAllDocMaster
        );
      /* FOLDER_MOVE: 다른 폴더로 이동 */
      case "FOLDER_MOVE":
        if (
          !checkNotAllDocMaster ||
          !utilsCommon.checkLicenseAvailable("folderMoveOwner")
        ) {
          changeModalType("FOLDER_MOVE");
        } else {
          toast.toastMsg(nanoid(), t("file.alert.noMasterFile"), "error");
        }
        return (
          !checkNotAllDocMaster ||
          !utilsCommon.checkLicenseAvailable("folderMoveOwner")
        );
      /* SHARE_FILE_TO_WORKGROUP: 다른 워크그룹으로 이동 
        SET_FILE_AUTH: 파일 권한
      */
      case "SHARE_FILE_TO_WORKGROUP":
      case "SET_FILE_AUTH":
        if (!checkNotAllDocMaster) {
          changeModalType(type);
        } else {
          toast.toastMsg(
            nanoid(),
            type === "SHARE_FILE_TO_WORKGROUP"
              ? t("file.alert.noMaster.shareWorkgroup")
              : t("file.alert.noMaster.chnageAuth"),
            "error"
          );
        }
        return !checkNotAllDocMaster;
    }
  };

  const changeFilterByKey = (key: string, value: any) => {
    if (key !== "page") setButtonClick(buttonClick + 1);

    if (key === "order") {
      let newValue = "namedesc";
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "file") {
          if (filter.order.includes("date")) {
            newValue = "filedesc";
          } else {
            newValue = filter.order === "filedesc" ? "file" : "filedesc";
          }
        } else {
          if (filter.order.includes("name")) {
            newValue = "datedesc";
          } else {
            newValue = filter.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
      changeFilter({
        ...filter,
        page: 0,
        order: newValue.replace("name", "file"),
      });
    } else if (key === "date") {
      toggleIsReadRequest(false);
      if (typeof value !== "object") {
        changeDateFilter(value);
        changeFilter({
          ...filter,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().endOf("day").valueOf(),
          },
          page: 0,
        });
      } else {
        changeDateFilter("custom");
        changeFilter({
          ...filter,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
      }
    } else if (key === "fileType") {
      toggleIsReadRequest(false);
      changeFileFilter(value);
      changeFilter({
        ...filter,
        masterUserId: value === "MINE" ? myId : "",
        page: 0,
        readType:
          value === "FAV" ? "favorit" : value === "UNREAD" ? "unread" : "",
      });
    } else if (key === "readRequest") {
      toggleIsReadRequest(value);
      if (value) {
        changeDateFilter("all");
        changeFileFilter("ALL");
        getReadRequestContentList({
          pos: 0,
          posCount: 50,
          workgroupId: workgroupId,
        });
      } else {
        changeFilter(INIT_FILTER);
        getContentList({
          ...filter,
          masterUserId: "",
          readType: "",
          date: {
            start: 0,
            end: 0,
          },
        });
      }
    } else if (key === "page") {
      if (
        docInfo &&
        docInfo?.docs?.doc &&
        docInfo?.docs?.doc.length < docInfo?.total
      )
        changeFilter({
          ...filter,
          [key]: value,
        });
      return;
    }
    document.getElementById("docTable")?.scrollTo(0, 0);
  };
  const renderFilter = () => {
    return (
      <Box classes="workgroupFile-filter">
        <Button
          leadingIcon={<Icons variant="line" label="redoLeft" />}
          btnStyle="icon"
          onClick={handleInitFilter}
          classes="mg mb-4"
          size={"sm"}
          state={
            dateFilter === "all" && fileTypeFilter === "ALL" && !isReadRequest
              ? "disable"
              : "default"
          }
        />
        <Dropdown
          btnStyle="round"
          classes={"mg ml-12"}
          btnSize="rd"
          placeholder={t("file.filter.fileType")}
          buttonWidth={240}
          showValue
          value={
            fileTypeFilter === "ALL"
              ? ""
              : FILE_MENU_LIST.filter((item) => item.key === fileTypeFilter)[0]
                  .resource
          }
          buttonClick={buttonClick}
        >
          {FILE_MENU_LIST.map((item) => (
            <DropdownItem
              label={item.resource}
              type="check"
              checked={item.key === fileTypeFilter}
              onClick={() => changeFilterByKey("fileType", item.key)}
              checkColor={item.key === fileTypeFilter}
              state="selected"
            />
          ))}
        </Dropdown>
        <DateDropdown
          filter={filter}
          buttonClick={buttonClick}
          setButtonClick={setButtonClick}
          dateFilter={dateFilter}
          changeFilterByKey={changeFilterByKey}
        />
        <Dropdown
          btnStyle="round"
          classes={"mg ml-12"}
          btnSize="rd"
          placeholder={t("header.setAlarm.request")}
          buttonWidth={224}
          showValue
          value={!isReadRequest ? "" : FILE_READ_REQUEST_LIST[0].resource}
          buttonClick={buttonClick}
        >
          {FILE_READ_REQUEST_LIST.map((item) => (
            <DropdownItem
              label={item.resource}
              type="check"
              checked={item.value === isReadRequest}
              onClick={() => changeFilterByKey("readRequest", item.value)}
              checkColor={item.value === isReadRequest}
              state="selected"
            />
          ))}
        </Dropdown>
      </Box>
    );
  };
  const renderUpperActionBox = (docInfos?: DocInfo[]) => {
    return docInfos?.length === 0 ? (
      <>
        <Button
          btnStyle={"link"}
          leadingIcon={<Icons variant="line" label="folder" />}
          label={t("file.action.createFolder")}
          onClick={() => changeModalType("CREATE_FOLDER")}
        />
        {utilsCommon.checkUploadFilePermission(loginDto) && (
          <Button
            btnStyle={"link"}
            leadingIcon={<Icons variant="line" label="upload" />}
            classes="mg ml-8"
            label={t("file.action.upload")}
            onClick={() => changeModalType("MULTIPLE_FILE_UPLOAD")}
          />
        )}
      </>
    ) : (
      docInfos && (
        <>
          {showRequestSubMenu && (
            <DropdownBody
              minWidth={190}
              location={{
                x: document.getElementById("docAside")
                  ? i18n.language.includes("en")
                    ? 305
                    : 280
                  : i18n.language.includes("en")
                  ? -145
                  : -120,
                y: docInfos.length === 1 ? 140 : 100,
              }}
              dropdownRef={requestMemuBoxRef}
            >
              <DropdownItem
                label={"Dropbox"}
                onClick={() => {
                  changeModalType("SHARE_TO_DROPBOX");
                  setButtonClick(buttonClick > 99999 ? 1 : buttonClick + 1);
                  changeCheckedFilelist(docInfos);
                  setShowRequestSubMenu(false);
                }}
              />
            </DropdownBody>
          )}
          <Button
            btnStyle={"link"}
            state={
              !docInfos || docInfos?.length > MAX_CHECK_COUNT
                ? "disable"
                : "default"
            }
            leadingIcon={<Icons variant="line" label="download" />}
            label={t("file.action.download")}
            onClick={() =>
              handleDocsDownload({
                syncIds: docInfos?.map((item) => item.syncId),
                toast: toast,
                getContentsDownload: getContentsDownload,
              })
            }
          />
          <Button
            btnStyle={"link"}
            type="error"
            leadingIcon={<Icons variant="line" label="delete" />}
            classes="mg ml-8"
            label={t("common.delete")}
            onClick={() =>
              doDeleteDocument(docInfos, toast, getDocDelete, () => {
                setButtonClick(buttonClick + 1);
              })
            }
          />
          <Dropdown
            btnStyle="link"
            placeholder={t("common.more")}
            btnSize="lg"
            buttonClick={buttonClick}
            dropdownMaxWidth={i18n.language.includes("ko") ? 208 : 258}
            buttonWidth={i18n.language.includes("ko") ? 208 : 258}
            align="right"
            value={t("common.more")}
            classes="mg ml-8 upperaction"
            leadingIcon={<Icons variant="line" label="moreVertical" />}
          >
            {docInfos.length === 1 &&
              utilsCommon.checkMenuAvailble("preview", docInfos[0]) && (
                <DropdownItem
                  label={t("file.action.open")}
                  frontIcon={<Icons variant="line" label="preview" isOn />}
                  onClick={() =>
                    handleDocPreview({
                      permission: "view",
                      workgroupId: docInfos[0]?.workgroup.workgroupId,
                      syncId: docInfos[0].syncId,
                      toast,
                      t,
                      revisionNo: docInfos[0]?.revisionNo,
                    })
                  }
                />
              )}
            <DropdownItem
              label={t("file.action.shareToOtherWorkgroup")}
              frontIcon={<Icons variant="line" label="people" />}
              onClick={() => {
                changeCheckedFilelist(docInfos);
                checkUpperActionValid("SHARE_FILE_TO_WORKGROUP", docInfos);
              }}
            />
            {window.eco.companyName === "linkApp" && (
              <DropdownItem
                label={t("account.app.exportFile")}
                frontIcon={<Icons variant="line" label="export" />}
                trailingIcon={
                  <Icons
                    variant="line"
                    label="chevron"
                    direction="right"
                    classes="mg ml-auto mr-0"
                    style={{ marginInlineEnd: 0 }}
                  />
                }
                onClick={() => setShowRequestSubMenu(true)}
              />
            )}
            <DropdownItem
              label="K-Assistant"
              frontIcon={<Icons variant="line" label="ai" />}
              onClick={() =>
                uploadToAIAssistant({
                  docs: docInfos,
                  checkAIDocPermission,
                  changeDragItem,
                  toast,
                })
              }
            />
            <DropdownItem
              label={t("file.action.addFav")}
              frontIcon={<Icons variant="fill" label="star" stroke="#F6C243" />}
              onClick={() =>
                handleSetContentFavorite({
                  docInfos: docInfos,
                  getContentFavorite: getContentFavorite,
                  page: "workgroupFile",
                  flag: true,
                  handleAfterSubmit: () => setButtonClick(buttonClick + 1),
                })
              }
            />
            <DropdownItem
              label={t("file.action.removeFav")}
              frontIcon={<Icons variant="line" label="star" isOn />}
              onClick={() =>
                handleSetContentFavorite({
                  docInfos: docInfos,
                  getContentFavorite: getContentFavorite,
                  page: "workgroupFile",
                  flag: false,
                  handleAfterSubmit: () => setButtonClick(buttonClick + 1),
                })
              }
            />
            <DropdownItem
              label={t("common.move")}
              frontIcon={<Icons variant="line" label="foldermove" />}
              onClick={() => {
                changeCheckedFilelist(docInfos);
                checkUpperActionValid("FOLDER_MOVE", docInfos);
              }}
            />
            <DropdownItem
              label={t("file.action.auth")}
              frontIcon={<Icons variant="line" label="access" />}
              onClick={() => {
                changeCheckedFilelist(docInfos);
                checkUpperActionValid("SET_FILE_AUTH", docInfos);
              }}
            />
            <DropdownItem
              label={t("file.action.changeOwner")}
              disabled={!docInfos || docInfos?.length > MAX_CHECK_COUNT}
              frontIcon={<Icons variant="line" label="crown" />}
              onClick={() => {
                changeCheckedFilelist(docInfos);
                checkUpperActionValid("CHANGE_FILE_MASTER", docInfos);
              }}
            />
          </Dropdown>
        </>
      )
    );
  };
  const onDrop = async (
    acceptedFiles: File[],
    fileRejections: FileRejection[],
    e: any
  ) => {
    e.preventDefault();
    e.stopPropagation();
    changeUploadFiles(
      uploadFiles ? [...uploadFiles, ...acceptedFiles] : [...acceptedFiles]
    );
    /** upload Progress 값에 저장하기 */
    const uuid = nanoid();
    for (let i = 0; i < acceptedFiles.length; i++) {
      const file: FileWithPath = acceptedFiles[i];
      const uploadFile: UploadFile = {
        isMultiple: false,
        uuid: uuid + i,
        fileName: file.name,
        fileSize: file.size,
        workgroupId: workgroupId ?? "",
        workgroupName: workgroupId ?? "",
        status: "WAIT", // WAIT, ING, SUCCESS, FAIL
        errorMsg: "",
        file: acceptedFiles[i],
      };
      setAddUploadProgressFiles(uploadFile);
    }
    /** 업로드 하기 전 파일 체크 */
    for (let i = 0; i < acceptedFiles.length; i++) {
      const file: File = acceptedFiles[i];
      const fileExt = file.name.split(/[.]+/).pop();
      let errorMsg = "";
      if (
        !fileExt ||
        (loginDto.serviceConfig.allowedExtensions &&
          loginDto.serviceConfig.allowedExtensions?.length > 0 &&
          !loginDto.serviceConfig.allowedExtensions?.includes(fileExt))
      ) {
        errorMsg = t("file.alert.notSupportedExt");
      } else if (
        (!loginDto.serviceConfig.allowedExtensions ||
          loginDto.serviceConfig.allowedExtensions?.length === 0) &&
        loginDto.serviceConfig.disableExtensions.includes(fileExt)
      ) {
        errorMsg = t("file.alert.notSupportedExt");
      } else if (file.size === 0) {
        errorMsg = t("file.alert.notAllowZeroSize");
      } else if (
        file.size >
        loginDto.ecoCommonConfig.fileUploadMaxSizeMB * 1024 * 1024
      ) {
        errorMsg = t("file.alert.notAllowMaxSize", {
          num: loginDto.ecoCommonConfig.fileUploadMaxSizeMB,
        });
      }
      if (errorMsg !== "") {
        const uploadFile: UploadFile = {
          uuid: uuid + i,
          fileName: file.name,
          fileSize: file.size,
          workgroupId: workgroupId ?? "",
          workgroupName: workgroupId ?? "",
          status: "FAIL", // WAIT, ING, SUCCESS, FAIL
          errorMsg,
        };
        setUpdateUploadProgressFiles(uploadFile);
        continue;
      } else {
        await getDocUploadUidCreate().then(async (resp: any) => {
          let resp1 = await handleUploadFile(resp.payload, {
            isMultiple: false,
            uuid: uuid + i,
            fileName: file.name,
            fileSize: file.size,
            workgroupId: workgroupId ?? "",
            workgroupName: workgroupId ?? "",
            status: "WAIT", // WAIT, ING, SUCCESS, FAIL
            errorMsg: "",
            file: acceptedFiles[i],
          });
        });
      }
    }
  };
  const handleUploadDocumentComplete = async (uid: string) => {
    const urlParmas = new URLSearchParams(window.location.search);
    const givenFolderId = urlParmas.get("folderId");
    return await doDocUploadFileComplete(uid, {
      workgroupId: workgroupId ?? "",
      permissionList: [{ changeCode: "CREATE", targetType: "WORKGROUP" }],
      folderId: givenFolderId && givenFolderId !== "ROOT" ? givenFolderId : "",
    });
  };
  const handleUploadFile = async (
    uid: string,
    targetFile: UploadFile
  ): Promise<void> => {
    if (!targetFile.file) return;
    const uploadFile: UploadFile = {
      uuid: targetFile?.uuid,
      fileName: targetFile?.fileName ?? "",
      fileSize: targetFile?.fileSize ?? 0,
      workgroupId: workgroupId ? workgroupId : "",
      workgroupName: workgroupId ? workgroupId : "",
      status: "ING", // WAIT, ING, SUCCESS, FAIL
      errorMsg: "",
      file: targetFile?.file,
    };
    setUpdateUploadProgressFiles(uploadFile);
    let resp = "NOT_YET";
    let fileId = "";
    for (let i = 0; i < 3 && ["NOT_YET", "BAD_REQUEST"].includes(resp); i++) {
      const uploadResp = await doDocUploadFile(
        uid,
        targetFile?.file,
        setProgressPercent
      );
      if (!uploadResp.payload.error) {
        fileId = uploadResp.payload.fileId;
        resp = "";
        setUpdateUploadProgressFiles({
          uuid: targetFile?.uuid,
          fileName: targetFile?.fileName ?? "",
          fileSize: targetFile?.fileSize ?? 0,
          workgroupId: workgroupId ? workgroupId : "",
          workgroupName: workgroupId ? workgroupId : "",
          status: uploadResp.payload.error ? "FAIL" : "ING", // WAIT, ING, SUCCESS, FAIL
          errorMsg: uploadResp.payload.error?.message ?? "",
          fileId: uploadResp.payload?.fileId ?? "",
        });
      } else {
        resp = uploadResp.payload.error.message;
        utilsCommon.sleep(2000);
      }
    }
    const completeResp: any = await handleUploadDocumentComplete(uid);
    if (completeResp.payload) {
      completeResp.payload[0]?.syncId &&
        changeRequiredRecallSyncIds([
          ...requiredRecallSyncId,
          completeResp.payload[0]?.syncId,
        ]);
      setUpdateUploadProgressFiles({
        uuid: targetFile?.uuid,
        fileName: targetFile?.fileName ?? "",
        fileSize: targetFile?.fileSize ?? 0,
        workgroupId: workgroupId ? workgroupId : "",
        workgroupName: workgroupId ? workgroupId : "",
        status: resp !== "" || completeResp.payload.error ? "FAIL" : "SUCCESS", // WAIT, ING, SUCCESS, FAIL
        errorMsg: resp ?? completeResp.payload.error?.message ?? "",
        fileId: fileId ?? "",
      });
    } else if (completeResp?.error) {
      setUpdateUploadProgressFiles({
        uuid: targetFile?.uuid,
        fileName: targetFile?.fileName ?? "",
        fileSize: targetFile?.fileSize ?? 0,
        workgroupId: workgroupId ? workgroupId : "",
        workgroupName: workgroupId ? workgroupId : "",
        status: resp !== "" || completeResp?.error ? "FAIL" : "SUCCESS", // WAIT, ING, SUCCESS, FAIL
        errorMsg:
          completeResp?.error?.message ?? t("common.alert.internalError"),
        fileId: fileId ?? "",
      });
      // toast.toastMsg(
      //   nanoid(),
      //   completeResp?.error?.message ?? t("common.alert.internalError"),
      //   "error"
      // );
    }
  }; /** 필터 초기화 상태인지 확인*/
  const isInitFilter = () => {
    return dateFilter === "all" && fileTypeFilter === "ALL" && !isReadRequest;
  };
  const handleInitFilter = () => {
    changeDateFilter("all");
    changeFileFilter("ALL");
    toggleIsReadRequest(false);
    changeFilter(INIT_FILTER);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const checkModal = () => {
      const open = !!document.querySelector(".fds-modal-backdrop-root.on");
      setIsModalOpen(open);
    };

    const observer = new MutationObserver(checkModal);
    observer.observe(document.body, { childList: true, subtree: true });

    checkModal(); // 초기 확인

    return () => observer.disconnect();
  }, []);
  return (
    <Box width={"100%"} height={"calc(100% - 146px)"} classes={"workgroupFile"}>
      {modalType === "SHARE_FILE_TO_WORKGROUP" && (
        <WorkgroupAddModal
          open={modalType === "SHARE_FILE_TO_WORKGROUP"}
          uploadedFiles={checkedFileList}
          onClose={() => changeModalType("CLOSE")}
          createType={"SHARE_TO_WORKGROUP"}
        />
      )}
      {modalType === "MULTIPLE_FILE_UPLOAD" && (
        <FileUploadModal
          open={true}
          workgroupId={workgroupId}
          onClose={() => changeModalType("CLOSE")}
        />
      )}
      {modalType === "CREATE_FOLDER" && (
        <CreateNewFolderModal
          open={true}
          workgroupId={workgroupId}
          onClose={() => changeModalType("CLOSE")}
        />
      )}
      {modalType === "CHANGE_FILE_MASTER" && checkedFileList && (
        <ChangeFileMasterModal
          open={modalType === "CHANGE_FILE_MASTER"}
          onClose={() => {
            changeModalType("CLOSE");
            changeCheckedFilelist(undefined);
          }}
          docInfos={checkedFileList}
        />
      )}
      {modalType === "SET_FILE_AUTH" && (
        <ChangeWorkgroupFileAuthModal
          open={modalType === "SET_FILE_AUTH"}
          onClose={() => {
            changeModalType("CLOSE");
            changeCheckedFilelist(undefined);
          }}
          docInfos={checkedFileList}
        />
      )}
      {modalType === "FOLDER_MOVE" && checkedFileList && (
        <FolderMoveModal
          open={modalType === "FOLDER_MOVE" && !!checkedFileList}
          onClose={() => {
            changeModalType("CLOSE");
            changeCheckedFilelist(undefined);
          }}
          docInfo={checkedFileList}
        />
      )}
      {modalType === "SHARE_TO_DROPBOX" &&
        checkedFileList &&
        (!appState.appRegisterStatus.dropbox ? (
          <AppRegisterModal
            open={
              modalType === "SHARE_TO_DROPBOX" &&
              !appState.appRegisterStatus.dropbox
            }
            onClose={() => changeModalType("CLOSE")}
            handleAfter={() => changeModalType("CLOSE")}
            modalType={"CONNECT"}
            openLinkAppModal="open_dropbox"
          />
        ) : (
          <ChooseDriveFolderModal
            open={modalType === "SHARE_TO_DROPBOX" && !!checkedFileList}
            onClose={() => {
              changeModalType("CLOSE");
              changeCheckedFilelist(undefined);
            }}
            docInfo={checkedFileList}
          />
        ))}
      <Box height={56}>{renderFilter()}</Box>
      <Dropzone
        noClick
        noKeyboard
        ref={(node) => {
          if (node) dropzoneRef = node;
        }}
        multiple
        onDrop={onDrop}
        disabled={
          !utilsCommon.checkUploadFilePermission(loginDto) || isModalOpen
        }
      >
        {({ getRootProps, getInputProps, isDragActive, inputRef }) => (
          <div
            {...getRootProps({ classNames: "workgroup-dropzone" })}
            className={classNames("workgroup-dropzone", {
              accept: isDragActive,
              false: !isDragActive,
            })}
          >
            <input {...getInputProps()} />
            <Box
              classes={classNames("dropzone-dragging")}
              style={{ display: isDragActive ? "flex" : "none" }}
            >
              <img
                src={require("../../../shared/images/pages/File/UploadFile.png")}
                alt={"UploadFile"}
                height={110}
              />
              <Typography
                type="h3"
                textAlign="center"
                exactColor={getColor("COLOR_BG_PRIMARY")}
                classes="mg mt-20"
              >
                {t("file.dropHere")}
              </Typography>
              <Typography
                type="body2_rg"
                textAlign="center"
                exactColor={getColor("COLOR_BG_PRIMARY")}
                classes="mg mt-10"
              >
                {t("account.app.uploadToWorkgroup")}
              </Typography>
            </Box>
            <DocumentBottom
              filter={filter}
              changeFilterByKey={changeFilterByKey}
              // height={"calc(100% - 32px)"}
              height={"100%"}
              listTableHeight={
                !givenFolderId || givenFolderId === workgroupId
                  ? "calc(100vh - 359px)"
                  : "calc(100vh - 404px)"
              }
              cardTableHeight={"calc(100vh - 380px)"}
              docInfo={docInfo}
              isInitFilter={isInitFilter()}
              handleInitFilter={handleInitFilter}
              requiredRecallSyncId={requiredRecallSyncId}
              changeRequiredRecallSyncIds={changeRequiredRecallSyncIds}
              page="workgroupFile"
              handleClickButton={() => dropzoneRef.open()}
              tableUpperActionBox={renderUpperActionBox}
              endReached={() => changeFilterByKey("page", filter.page + 1)}
            />
          </div>
        )}
      </Dropzone>
    </Box>
  );
};

export default WorkgroupFile;
